import React from "react";
import {IconContext} from "react-icons";
import {AiFillInfoCircle, BiTargetLock, BsArrow90DegRight, FaPallet, FaRulerCombined, GiWeight,} from "react-icons/all";
import {RequestPayload} from "../sites/types/RequestPayload";

/**
 * React Component properties
 */
type Props = {
  searchResult: RequestPayload;
};

/**
 * Cross Innovation Class 2021
 *
 * Team: Kühne + Nagel
 *
 * Kunden Web App
 *
 * This component is used to display all infos about the delivery
 *
 * @author Tobias Ramm <winf103614@fh-wedel,de>
 * @version last modification: 29.06.2021
 *
 */
export function DeliveryInfoContainer(props: Props) {
  return (
    <div style={{ width: "100%" }}>
      <h3>Informationen zum Stückgut:</h3>

      <div className={"delivery_information_container"}>
        {/* Im Auftrag von */}
        <div className={"single_delivery_information"}>
          <IconContext.Provider value={{ color: "#003369", className: "icon" }}>
            <AiFillInfoCircle />
          </IconContext.Provider>
          <div className={"text_details"}>
            <h4>im Auftrag von</h4>
            <h2>{props.searchResult.senderName}</h2>
          </div>
        </div>

        {/* Gesndet von */}
        <div className={"single_delivery_information"}>
          <IconContext.Provider value={{ color: "#003369", className: "icon" }}>
            <BsArrow90DegRight />
          </IconContext.Provider>
          <div className={"text_details"}>
            <h4>von</h4>
            <h2>{props.searchResult.from}</h2>
          </div>
        </div>

        {/* Gesendet nach */}
        <div className={"single_delivery_information"}>
          <IconContext.Provider value={{ color: "#003369", className: "icon" }}>
            <BiTargetLock />
          </IconContext.Provider>
          <div className={"text_details"}>
            <h4>nach</h4>
            <h2>{props.searchResult.to}</h2>
          </div>
        </div>
      </div>

      <div className={"delivery_information_container"}>
        {/* Maße */}
        <div className={"single_delivery_information"}>
          <IconContext.Provider value={{ color: "#003369", className: "icon" }}>
            <FaRulerCombined />
          </IconContext.Provider>
          <div className={"text_details"}>
            <h4>Maße (Breite x Höhe x Tiefe)</h4>
            <h2>
              {props.searchResult.width} m x {props.searchResult.height} m x{" "}
              {props.searchResult.depth} m
            </h2>
          </div>
        </div>

        {/* Gewicht */}
        <div className={"single_delivery_information"}>
          <IconContext.Provider value={{ color: "#003369", className: "icon" }}>
            <GiWeight />
          </IconContext.Provider>
          <div className={"text_details"}>
            <h4>Gewicht</h4>
            <h2>{props.searchResult.weight}</h2>
          </div>
        </div>

        {/* Lieferart */}
        <div className={"single_delivery_information"}>
          <IconContext.Provider value={{ color: "#003369", className: "icon" }}>
            <FaPallet />
          </IconContext.Provider>
          <div className={"text_details"}>
            <h4>Lieferart</h4>
            <h2>Frei Bordsteinkannte</h2>
          </div>
        </div>
      </div>
    </div>
  );
}
